import { render, staticRenderFns } from "./PlayerStats.vue?vue&type=template&id=1c0f1dae&scoped=true&"
import script from "./PlayerStats.vue?vue&type=script&lang=js&"
export * from "./PlayerStats.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStats.vue?vue&type=style&index=0&id=1c0f1dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f1dae",
  null
  
)

export default component.exports